export interface VoiceResponseDTO {
	voice_id: string
	name: string
	category?: string
	preview_url?: string
	samples?: { preview_url?: string }[]
	labels?: {
		accent?: string
		description?: string
		age?: string
		gender?: string
		use_case?: string
	}
	// Collection IDs - used to identify voice groups (e.g., Macedonian voices)
	collection_ids?: string[]
	high_quality_base_model_ids?: string[]
	sharing?: {
		status: string
	}
}

// Macedonian voices collection ID
export const MACEDONIAN_COLLECTION_ID = 'CQ1Bqs9gMz2dKrdEUuMS'
// Costa Rica voices collection ID
export const COSTA_RICA_COLLECTION_ID = 'Tuv9ByQoeJfSfvEQvG8p'
// Malaysia voices collection ID
export const MALAYSIA_COLLECTION_ID = 'G6SjbwN82qtxuTKBp1pb'
